import React from 'react';
import './Avatar.scss'

interface AvatarProps {
    type?: 'name' | 'name-text' | 'icon' | 'big' | 'group';
    name?: string;
    secondText?: string;
    images: string[];
    onClick?: () => void;
}

const Avatar: React.FC<AvatarProps> = ({ type = 'name', name = '', secondText = '', images, onClick }) => {
    return (
        <div className={`tapps-avatar avatar-${type}`}>
            {type !== 'group' && (
                <div className="tapps-avatar-image">
                    <img src={images[0]} alt="Avatar" />
                </div>
            )}
            {type === 'group' &&
                images.map((image, index) => (
                    index < images.length - 2 ? (
                        <div key={index} className="tapps-avatar-image">
                            <img src={image} alt="Avatar" />
                        </div>
                    ) : index === images.length - 2 ? (
                        <div key={index} className="tapps-avatar-image">
                            <img src={image} alt="Avatar" />
                        </div>
                    ) : (
                        <div key={index} className="tapps-avatar-count">
                            +{images.length - index}
                        </div>
                    )
                ))}
            {type !== 'group' && (
                <div className="tapps-avatar-text">
                    {name}
                    {type === 'name-text' && <div className="secondText">{secondText}</div>}
                </div>
            )}
            {type === 'icon' && (
                <div className="tapps-avatar-icon" onClick={onClick}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M3.64645 5.65967C3.84171 5.44678 4.15829 5.44678 4.35355 5.65967L7.64645 9.25C7.84171 9.4629 8.15829 9.4629 8.35355 9.25L11.6464 5.65968C11.8417 5.44678 12.1583 5.44678 12.3536 5.65968C12.5488 5.87257 12.5488 6.21775 12.3536 6.43065L9.06066 10.021C8.47487 10.6597 7.52513 10.6597 6.93934 10.021L3.64645 6.43065C3.45118 6.21775 3.45118 5.87257 3.64645 5.65967Z"
                            fill="#1C1C1C"
                            fillOpacity="0.2"
                        />
                    </svg>
                </div>
            )}
        </div>
    );
};

export default Avatar;